function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON } from './constants';
import theme from './theme';
import sx from './sx';

function IconWrapper({
  icon: IconComponent,
  className,
  ...rest
}) {
  return /*#__PURE__*/React.createElement(IconComponent, _extends({
    className: className
  }, rest));
}

IconWrapper.displayName = "IconWrapper";
const StyledOcticon = styled(IconWrapper).withConfig({
  displayName: "StyledOcticon",
  componentId: "sc-7ly0uy-0"
})(["", " ", ""], COMMON, sx);
StyledOcticon.defaultProps = {
  theme,
  size: 16
};
StyledOcticon.propTypes = { ...COMMON.propTypes,
  ...sx.propTypes,
  icon: PropTypes.elementType.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['small', 'medium', 'large'])]),
  theme: PropTypes.object,
  verticalAlign: PropTypes.oneOf(['middle', 'text-bottom', 'text-top', 'top'])
};
export default StyledOcticon;